import { defineMessages } from '../define';

export default defineMessages({
  'projects.status.draft': { ru: 'Черновик', en: 'Draft' },
  'projects.status.uploading': { ru: 'Загрузка', en: 'Uploading' },
  'projects.status.transcribing': { ru: 'Расшифровка', en: 'Transcribing' },
  'projects.status.analyzing': { ru: 'Анализ', en: 'Analyzing' },
  'projects.status.planning': { ru: 'Сценарий', en: 'Scripting' },
  'projects.status.rendering': { ru: 'Монтируем', en: 'Editing' },
  'projects.status.delivering': { ru: 'Отправка', en: 'Sending' },
  'projects.status.done': { ru: 'Готов', en: 'Ready' },
  'projects.status.failed': { ru: 'Ошибка', en: 'Failed' },
  'projects.status.expired': { ru: 'Истёк', en: 'Expired' },
  'projects.expiry.expired': { ru: 'срок хранения истёк', en: 'storage period has ended' },
  'projects.expiry.left': {
    ru: { one: 'хранится ещё {n} день', few: 'хранится ещё {n} дня', many: 'хранится ещё {n} дней', other: 'хранится ещё {n} дня' },
    en: { one: 'stored for {n} more day', other: 'stored for {n} more days' },
  },
  'projects.expiry.oneDay': { ru: 'хранится ещё день', en: 'stored for 1 more day' },
  'projects.title': { ru: 'Ролики', en: 'Reels' },
  'projects.loading': { ru: 'Загружаем список', en: 'Loading your reels' },
  'projects.empty.title': { ru: 'Пока пусто', en: 'Nothing here yet' },
  'projects.empty.hint': { ru: 'Создайте первый ролик — это займёт несколько минут.', en: 'Create your first reel. It only takes a few minutes.' },
  'projects.untitled': { ru: 'Новый ролик', en: 'New reel' },
  'projects.rename.aria': { ru: 'Переименовать: {name}', en: 'Rename: {name}' },
  'projects.rename.label': { ru: 'Название ролика', en: 'Reel name' },
  'projects.saving': { ru: 'Сохраняем…', en: 'Saving…' },
  'projects.save': { ru: 'Сохранить', en: 'Save' },
  'projects.cancel': { ru: 'Отмена', en: 'Cancel' },
  'projects.open': { ru: 'Открыть', en: 'Open' },
  'projects.delete': { ru: 'Удалить', en: 'Delete' },
  'projects.delete.confirm': { ru: 'Удалить проект и все его файлы?', en: 'Delete this project and all its files?' },
  'projects.new': { ru: 'Новый монтаж', en: 'New edit' },
});
